<template>
    <div class="form-box">
        <div class="form-left">
            <div v-for="(item,index) in dataTree" :key="index" :class="(curId==index?'on':'')" @click="handleNodeClick(item,index)" style="width:100%;height:4vh;position: relative;display: flex;align-content: center;align-items: center;padding-left: 1vh;cursor: pointer;">
                <p class="nowrap" :title="item.name" style="width:100%;">{{item.name}}</p>
            </div>
        </div>
        <div class="form-right">
            <div style="width:100%;height:5vh;padding-left:1vw;background:#fff;display:flex;align-items: center;">
                <!-- <el-page-header @back="goBack" content="项目关键节点实际完成情况"></el-page-header> -->
                <p style="font-size: 1.2vw;">项目关键节点实际完成情况</p>
            </div>
            <div style="width:100%;height:calc( 100% - 5vh );position: relative;padding:1vh;background:#fff;">
                <el-table :data="tableData" border style="width: 100%" height="100%" :header-row-class-name="'table-head'">
                    <template slot="empty">
                        <p>{{dataText}}</p>
                    </template>
                    <el-table-column prop="index" label="序号" width="80">
                        <template slot-scope="scope">
                            <span>{{scope.row.index}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="month" label="年月">
                        <template slot-scope="scope">
                            <span>{{scope.row.month||''}}</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="baseMoney" label="基础开挖">
                        <template slot-scope="scope">
                            <div v-if="!scope.row['基础开挖']"></div>
                            <div v-else-if="scope.row['基础开挖']==''">未开始</div>
                            <span v-else-if="scope.row['基础开挖'].completeRate && scope.row['基础开挖'].completeRate!=100">{{scope.row['基础开挖']}}%</span>
                            <div v-else-if="scope.row['基础开挖'].completeRate && scope.row['基础开挖'].completeRate==100">
                                <el-image  style="width: 100px; height: 100px" :src="scope.row['基础开挖'].url" :preview-src-list="scope.row['基础开挖'].srcList">
                                </el-image>
                                <span>{{scope.row['基础开挖'].describes}}（{{scope.row['基础开挖'].completeRate}}%）</span>
                            </div>
                        </template>
                    </el-table-column> -->
                    <el-table-column :label="item.nodeTypeName" v-for="(item,index) in cols" :key="index">
                        <template slot-scope="scope">
                            <div v-if="!scope.row[item.nodeTypeName] || scope.row[item.nodeTypeName]==''">- -</div>
                            <div @click="dialogInfo(scope.row[item.nodeTypeName])" v-else-if="scope.row[item.nodeTypeName].completeRate && scope.row[item.nodeTypeName].completeRate==100" style="display: flex;align-items: center;justify-content: center;color:#409eff">
                                <!-- <el-image 
                                    style="width: 100px; height: 100px"
                                    :src="scope.row[item.nodeTypeName].url" 
                                    :preview-src-list="scope.row[item.nodeTypeName].srcList">
                                </el-image> -->
                                <p style="padding-left:5px;">
                                    <!-- <span style="width:100%;display: inline-block;">{{scope.row[item.nodeTypeName].describes}}</span> -->
                                    <span style="width:100%;display: inline-block;">{{scope.row[item.nodeTypeName].completeRate}}%</span>
                                </p>
                            </div>
                            <span v-else>{{scope.row[item.nodeTypeName]}}%</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="cumulativePay" label="结构封顶">
                        <template slot-scope="scope">
                            <div v-if="!scope.row['结构封顶']"></div>
                            <div v-else-if="scope.row['结构封顶']==''">未开始</div>
                            <span v-else-if="scope.row['结构封顶'].completeRate && scope.row['结构封顶'].completeRate!=100">{{scope.row['结构封顶']}}%</span>
                            <div v-else-if="scope.row['结构封顶'].completeRate && scope.row['结构封顶'].completeRate==100">
                                <el-image 
                                    style="width: 100px; height: 100px"
                                    :src="url" 
                                    :preview-src-list="srcList">
                                </el-image>
                                <span>{{scope.row['结构封顶'].describes}}（{{scope.row['结构封顶'].completeRate}}%）</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="cumulativePay" label="结构验收">
                        <template slot-scope="scope">
                            <span>{{scope.row.cumulativePay}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="cumulativePay" label="安装工程">
                        <template slot-scope="scope">
                            <span>{{scope.row.cumulativePay}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="cumulativePay" label="装饰工程">
                        <template slot-scope="scope">
                            <span>{{scope.row.cumulativePay}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="cumulativePay" label="室外工程">
                        <template slot-scope="scope">
                            <span>{{scope.row.cumulativePay}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="cumulativePay" label="竣工验收">
                        <template slot-scope="scope">
                            <span>{{scope.row.cumulativePay}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="cumulativePay" label="竣工移交">
                        <template slot-scope="scope">
                            <span>{{scope.row.cumulativePay}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="cumulativePay" label="竣工结算">
                        <template slot-scope="scope">
                            <span>{{scope.row.cumulativePay}}</span>
                        </template>
                    </el-table-column> -->
                </el-table>
            <el-dialog
              title="详情"
              :visible.sync="temperVis"
              center
              :append-to-body="true"
              :lock-scroll="false"
              width="30%"
              style="height: 100%"
            >
              <el-form
                :model="info"
                ref="creatForm"
                label-width="100px"
                :label-position="labelPosition"
              >
                <el-form-item label="图片：">
                    <el-image 
                    style="width: 100px; height: 100px"
                    :src="info.url" 
                    :preview-src-list="info.srcList">
                  </el-image>
                </el-form-item>
                <el-form-item label="描述：">
                  <el-input
                    style="width: 217px"
                    v-model="info.describes"
                    autocomplete="off"
                    type="textarea"
                    :rows="2"
                    readonly
                  ></el-input>
                </el-form-item>
              </el-form>
              <!-- <div>
                   <el-form>
                   </el-form>
                  <el-image 
                    style="width: 100px; height: 100px"
                    :src="info.url" 
                    :preview-src-list="info.srcList">
                  </el-image>
              </div> -->
              <!-- <div slot="footer" class="dialog-footer">
                <el-button @click="temperVis = false">取 消</el-button>
                <el-button type="primary" @click="sumbitEquip('creatForm')"
                  >确 定</el-button
                >
              </div> -->
            </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
import base from '../../../untils/base'
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
export default {
    data(){
        return{
            labelPosition: 'right',
            info:'',
            temperVis:false,
            groupId:'',
            dataTree:[],
            defaultProps: {
                children: 'list',
                label: 'name'
            },
            projectId:'',//当前项目id
            currentNodekey:'',//当前树形选中值
            expandedkeys:[],//树形展开值
            dataText: '数据加载中...',
            tableData:[],
            curId:0,
            cols:[{nodeTypeName:'基础开挖'},{nodeTypeName:'正负零'},{nodeTypeName:'结构封顶'},{nodeTypeName:'结构验收'},{nodeTypeName:'安装工程'},{nodeTypeName:'装饰工程'},{nodeTypeName:'室外工程'},{nodeTypeName:'竣工验收'},{nodeTypeName:'竣工移交'},{nodeTypeName:'竣工结算'}],//列
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        this.getLeftMenu()
        // this.getData()
    },
    methods:{
        //获取侧边树
        getLeftMenu(){
            var that = this
            if(util.session.get('roleId')=='5'){
                myHttp.getProjectPageListByEntIdAndJoinType({
                    entId:this.groupId,
                    pageNum:1,
                    pageSize:10000
                }).then(function(resp){
                    if(resp.data.code=='200'){
                        var list = resp.data.data.pageInfo.list||[]
                        that.dataTree = list
                        if (list.length > 0 && that.projectId=='') {
                            that.projectId= list[0].id
                            that.getData()
                        }
                    }
                })
            }else{
                myHttp.getEntProjectList({
                    groupId: this.groupId,
                    pageNum:1,
                    pageSize:10000
                }).then(function(resp) {
                    if (resp.data.code == '200') {
                        var list = resp.data.data.entProject.list || []
                        that.dataTree = list
                        if (list.length > 0 && that.projectId=='') {
                            that.projectId= list[0].projectId
                            that.getData()
                        }
                        if(list.length==0){
                            that.dataText = '暂无数据'
                        }
                    }else{
                        that.dataText = '暂无数据'
                    }
                })
            }
        },
        //树形点击
        handleNodeClick(e,index){
            if(util.session.get('roleId')=='5'){
                this.projectId = e.id
            }else{
                this.projectId = e.projectId
            }
            this.curId = index
            this.getData()
        },
        //获取数据
        getData(){
            if(!this.projectId||this.projectId==''){
                this.tableData = []
                this.cols = [{nodeTypeName:'基础开挖'},{nodeTypeName:'正负零'},{nodeTypeName:'结构封顶'},{nodeTypeName:'结构验收'},{nodeTypeName:'安装工程'},{nodeTypeName:'装饰工程'},{nodeTypeName:'室外工程'},{nodeTypeName:'竣工验收'},{nodeTypeName:'竣工移交'},{nodeTypeName:'竣工结算'}]
                this.dataText = '暂无数据'
                return
            }
            var that = this
            this.tableData = []
            myHttp.actualExecution({
                projectId:this.projectId
            }).then(function(resp){
                // console.log(resp)
                if(resp.data.code=='200'){
                    var list = resp.data.data.list||[]
                    that.cols  = resp.data.data.title && resp.data.data.title.length>0?resp.data.data.title:[{nodeTypeName:'基础开挖'},{nodeTypeName:'正负零'},{nodeTypeName:'结构封顶'},{nodeTypeName:'结构验收'},{nodeTypeName:'安装工程'},{nodeTypeName:'装饰工程'},{nodeTypeName:'室外工程'},{nodeTypeName:'竣工验收'},{nodeTypeName:'竣工移交'},{nodeTypeName:'竣工结算'}]
                    for(var i=0;i<list.length;i++){
                        list[i].index = i+1
                        for(var item in list[i]){
                            if(list[i][item] && list[i][item].picture){
                                if(list[i][item].picture.indexOf('http')>-1){
                                    list[i][item].url = list[i][item].picture
                                    list[i][item].srcList = [list[i][item].picture]
                                }else{
                                    list[i][item].url = base.httpCtx+list[i][item].picture
                                    list[i][item].srcList = [base.httpCtx+list[i][item].picture]
                                }
                            }
                        }
                    }
                    that.tableData = list
                    if(list.length==0){
                        that.dataText = '暂无数据'
                    }
                }else{
                    that.cols = [{nodeTypeName:'基础开挖'},{nodeTypeName:'正负零'},{nodeTypeName:'结构封顶'},{nodeTypeName:'结构验收'},{nodeTypeName:'安装工程'},{nodeTypeName:'装饰工程'},{nodeTypeName:'室外工程'},{nodeTypeName:'竣工验收'},{nodeTypeName:'竣工移交'},{nodeTypeName:'竣工结算'}]
                    that.dataText = '暂无数据'
                }
            })
        },

        //返回
        goBack(){
            this.$router.go(-1)
        },
        dialogInfo(item){
            console.log(item)
            this.info = item
            this.temperVis=true
            
        }
    }
}
</script>

<style scoped>
    .form-box{
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        padding: 1vh;
    }
    .form-left{
        width:15vw;
        height: 100%;
        position: relative;
        background: #fff;
        padding: 1vh;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        align-items: flex-start;
    }
    .form-left .on{
        color: #2447D7;
    }
    .form-right{
        width: calc( 100% - 15vw );
        height: 100%;
        position: relative;
        padding-left: 1vh;
    }
</style>

<style>
    @import '../../../assets/css/common.css';
    .el-table--border th, .el-table__fixed-right-patch{
        border-bottom: 1px solid #303133;
    }
    .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
        border-right: 1px solid #303133;
    }
    .el-table td, .el-table th.is-leaf{
        border-bottom: 1px solid #303133;
    }
    .el-table--border, .el-table--group{
        border: 1px solid #303133;
    }
</style>